<template>
    <div class="form-container-reset">
        <div class="check-phone-reset-header">
            重置密码
        </div>
        <div class="check-phone-reset-tips">
            请确认需要修改密码的账号
        </div>
        <div class="list-container">
            <div
                :class="{'list-container-content': (companies.aidList).length < 3}"
            >
                <div
                    v-for="(item, index) in companies.aidList"
                    :key="index"
                    @click="chooiseCompany(item)"
                    class="list"
                >
                    <!-- <img v-if="item.icon === '0'" class="headerImg" src="../assets/default_avatar.png" /> -->
                    <div class="content-box">
                        <div class="content-detail">
                            <p
                                :ref="'company-' + index"
                                class="company"
                            >
                                {{ item.corp_short_name }}
                            </p>
                            <div class="info">
                                <p
                                    :ref="'person-' + index"
                                    class="info-title"
                                >
                                    {{ item.account }}({{ item.name }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-show="errMsg && curAid === item.aid"
                        class="error-content"
                    >
                        <v-icon
                            :style="{color: '#F75559'}"
                            name="v-error"
                            label="提示"
                        />
                        <span class="error-content-text">{{ errMsg }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom" />
    </div>
</template>

<script>
export default {
    props: {
        companies: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            errMsg: '',
            curAid: '',
        };
    },
    computed: {
        phoneNumber() {
            return this.companies.phoneNumber;
        },
    },
    methods: {
        chooiseCompany(item) {
            this.errMsg = '';
            this.curAid = item.aid;
            item.phoneNumber = this.phoneNumber;
            item.verifyCode = this.companies.verifyCode;
            const status = item.aid_status;
            if (status === 0) {
                this.$emit('phoneInfo', item);
            } else if (status === 2) {
                this.errMsg = '此账号存在违规行为，已被封禁，请联系管理员';
            } else if (status === 3) {
                this.errMsg = '此账号已被管理员停用，请联系管理员恢复';
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '../style.less';
.form-container-reset {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: -30px;
        width: 392px;
        height: 450px;
        background: #fff;
        border: 1px solid #ebedf2;
        border-radius: 6px;

        .check-phone-reset-header {
            margin-top: 36px;
            font-size: 16px;
            font-family: PingFangSC-Medium, sans-serif;
            font-weight: 500;
            text-align: center;
            color: rgba(0, 1, 10, 0.93);
            letter-spacing: 0;
        }

        .check-phone-reset-tips {
            margin: 12px 0;
            font-size: 14px;
            font-family: PingFangSC-Regular, sans-serif;
            text-align: center;
            color: rgba(3, 10, 38, 0.65);
            letter-spacing: 0;
        }
    }
.list-container {
    display: block;
    overflow-y: scroll;
    max-height: 328px;
    height: 100%;
    border-radius: 6px;
}
.list-container-content {
    display: block;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}
.list {
    background: #ffffff;
    border-radius: 6px;
    cursor: pointer;
    margin-bottom: 20px;

    .error-content {
        width: 312px;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;

        &-text {
            color: #F75559;
        }
    }

    .content-box {
        box-sizing: border-box;
        padding: 12px 16px;
        border: 1px solid rgba(17, 32, 70, 0.13);
        width: 312px;
        height: 72px;
        margin: 0 auto;
        border-radius: 6px;
    }
    .company {
        font-family: PingFangSC;
        color: rgba(0, 1, 10, 0.93);
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .info {
        font-family: PingFangSC;
        font-size: 14px;
        line-height: 20px;
        color: #a8abb3;
        margin-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        .info-title {
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .person {
            display: inline-block;
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;
        }
        .qq-code {
            display: inline-block;
            height: 20px;
        }
    }
}
.list:last-child {
    padding-bottom: 0;
}
.content-box:hover {
    border: 2px solid #4A70FF;
}
.bottom{
    height: 20px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background: #fff;
    border-bottom: 1px solid #ebedf2;
}
</style>
